import { BoxZoomHandler } from 'mapbox-gl'
import React, { useContext, useEffect, useState } from 'react'
import { MapContext } from '../component'

export const ActivationButton = ({
  locales
}: {
  locales: { deactivate: string; activate: string }
}) => {
  const { deactivate, activate } = locales
  const map = useContext(MapContext)
  const [isActive, setIsActive] = useState<boolean>(false)
  useEffect(() => {
    if (map) {
      if (!isActive) {
        let search: HTMLDivElement = document.getElementsByClassName(
          'ui text container nominatim'
        )[0] as HTMLDivElement

        // window.scrollTo({
        //   left: 0,
        //   top: search.offsetTop,
        //   behavior: 'smooth'
        // })

        map.resize()
        if (map.maincontainer)
          map.maincontainer.current.classList.remove('active')

        map.boxZoom.disable()
        map.scrollZoom.disable()
        map.dragRotate.disable()
        map.dragPan.disable()
        map.keyboard.disable()
        map.doubleClickZoom.disable()
        map.touchZoomRotate.disable()
        map.active = false
      }
      if (isActive) {
        if (map.maincontainer) map.maincontainer.current.classList.add('active')
        map.boxZoom.enable()
        map.scrollZoom.enable()
        map.dragRotate.enable()
        map.dragPan.enable()
        map.keyboard.enable()
        map.doubleClickZoom.enable()
        map.touchZoomRotate.enable()
        map.active = true
      }
    }
  }, [isActive])

  return (
    <button
      className={'ActivationButton ' + (isActive ? 'scroll' : 'map')}
      onClick={() => {
        setIsActive(!isActive)
      }}
    >
      {isActive ? deactivate : activate}
    </button>
  )
}
